export function base64ToBlob(base64: string, mimeType: string) {
  const bytesString = atob(base64);

  const bytesLength = bytesString.length;
  const bytes = new Uint8Array(bytesLength);

  for (let i = 0; i < bytesLength; i++) {
    bytes[i] = bytesString.charCodeAt(i);
  }

  return new Blob([bytes], { type: mimeType });
}
